import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { db, auth } from '../../firebaseConfig';
import { collection, query, where, getDocs, updateDoc, doc, getDoc, setDoc } from 'firebase/firestore';
import { useAuthState } from 'react-firebase-hooks/auth';
import '../../styles/AdminSuspendUser.css';

const AdminSuspendUser = () => {
  const [user, loading] = useAuthState(auth);
  const [isAdmin, setIsAdmin] = useState(false);
  const [loadingData, setLoadingData] = useState(false);
  const [reports, setReports] = useState([]);
  const [selectedReport, setSelectedReport] = useState(null);
  const [comment, setComment] = useState('');
  const [selectedRecipient, setSelectedRecipient] = useState('reporter'); // 'reporter' or 'reportedUser'
  const navigate = useNavigate();

  useEffect(() => {
    const checkAdmin = async () => {
      if (user) {
        const idTokenResult = await user.getIdTokenResult();
        if (idTokenResult.claims.admin) {
          setIsAdmin(true);
          fetchReports();
        } else {
          setIsAdmin(false);
          navigate('/'); // 管理者でない場合はリダイレクト
        }
      }
    };

    if (!loading) {
      checkAdmin();
    }
  }, [user, loading, navigate]);

  const fetchReports = async () => {
    setLoadingData(true);
    const q = query(collection(db, 'reports'), where('status', '==', 'pending'));
    const querySnapshot = await getDocs(q);
    const reportData = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    setReports(reportData);
    setLoadingData(false);
  };

  const handleSelectReport = (report) => {
    setSelectedReport(report);
  };

  const handleSendComment = async () => {
    if (!selectedReport || !comment.trim()) {
      alert('コメントを入力してください。');
      return;
    }
  
    const recipientId =
      selectedRecipient === 'reporter' ? selectedReport.reporter : selectedReport.reportedUser;
  
    if (!recipientId) {
      alert('選択された受信者が無効です。');
      return;
    }
  
    try {
      // 通知とインタラクションの一意のIDを生成
      const interactionId = `${selectedReport.id}-${new Date().getTime()}`;
  
      // 通知を受信者の`notifications`サブコレクションに保存
      await setDoc(doc(db, `members/${recipientId}/notifications`, interactionId), {
        title: `管理人からのコメント`,
        content: comment,
        relatedReportId: selectedReport.id,
        read: false,
        judge: 'sus', // judge フィールドを追加
        createdAt: new Date(),
      });
  
      // `reports/{reportId}/interaction`サブコレクションに保存
      await setDoc(doc(db, `reports/${selectedReport.id}/interaction`, interactionId), {
        adminId: user.uid,
        recipient: recipientId,
        content: comment,
        createdAt: new Date(),
      });
  
      setComment('');
      alert('コメントが送信されました。');
    } catch (error) {
      console.error('Error sending comment:', error);
      alert('コメントの送信に失敗しました。');
    }
  };
  
  if (loading || loadingData) {
    return <div>Loading...</div>;
  }

  if (!isAdmin) {
    return <div>Access denied. You do not have permission to view this page.</div>;
  }

  return (
    <div className="admin-suspend-user-container">
      <h2>Reports Management</h2>
      {reports.length === 0 ? (
        <div>No pending reports.</div>
      ) : (
        <ul>
          {reports.map((report) => (
            <li
              key={report.id}
              className="report-item"
              onClick={() => handleSelectReport(report)}
            >
              <p>{report.details}</p>
              <span className="report-date">
                {new Date(report.createdAt.toMillis()).toLocaleString()}
              </span>
            </li>
          ))}
        </ul>
      )}
      {selectedReport && (
        <div className="report-details">
          <h3>Report Details</h3>
          <p><strong>Report:</strong> {selectedReport.details}</p>
          <div>
            <label>
              <input
                type="radio"
                name="recipient"
                value="reporter"
                checked={selectedRecipient === 'reporter'}
                onChange={() => setSelectedRecipient('reporter')}
              />
              Reporter
            </label>
            <label>
              <input
                type="radio"
                name="recipient"
                value="reportedUser"
                checked={selectedRecipient === 'reportedUser'}
                onChange={() => setSelectedRecipient('reportedUser')}
              />
              Reported User
            </label>
          </div>
          <textarea
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            placeholder="コメントを入力してください"
            rows="4"
            className="comment-textarea"
          />
          <button onClick={handleSendComment} className="send-comment-button">
            コメントを送信
          </button>
        </div>
      )}
    </div>
  );
};

export default AdminSuspendUser;
